import type { Page } from '../../types';

const spendApproval: Page[] = [
  {
    pageType: 'question',
    title: 'Spend approval',
    name: 'spend-approval',
    description: '<p>License cost <strong>&pound;1,850 per financial year</strong></p>',
    disabled: [
      {
        field: 'paid-for-tableau-licence-last-financial-year',
        condition: 'equals',
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'inset',
        title: '',
        name: 'license-cost-calculation',
        hideOptionalLabel: true,
        insetContent:
          '<strong>Your total cost will be:</strong><br><br>${users} users &times; &pound;1,850 = <strong>${total}</strong>',
        insetVariables: {
          users: {
            type: 'previousAnswer',
            key: 'number-of-tableau-users',
          },
          total: {
            type: 'multipliedPreviousAnswer',
            key: 'number-of-tableau-users',
            multiplier: 1850,
            format: 'gbp',
          },
        },
      },
      {
        questionType: 'radio',
        title: 'Do you agree to pay the charge?',
        name: 'agree-to-pay-the-charge',
        options: ['Yes', 'No'],
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'Name of person approving charge',
        name: 'person-approving-charge',
        hint: 'Please ensure this person has the appropriate budget authority to sign off the purchase',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'Billing email address',
        name: 'billing-email-address',
        hint: 'The email address we should contact to arrange payment',
        rules: {
          required: true,
          email: true,
        },
      },
    ],
  },
];

export default spendApproval;
